export const BUILD_VERSION = 'v0.0.50';
